import _each from "lodash/each";

export default class ModalModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        activeModalName: "",
        closeModalName: "",
        focusInModal: true,
        modalContents: "",
        modalIndex: "",
        modalType: "",
        modalCloseReason: ""
      },

      getters: {
        isModalOpen: (state) => (name) => {
          // name指定であれば該当のモーダルがactiveかを確認
          if (name) {
            return state.activeModalName === name;
          } else {
            //無指定であればactiveがから出ないかを
            return state.activeModalName !== "";
          }
        }
      },

      // Mutations ----------------------------------------
      mutations: {
        openModal(state, payload) {
          state.activeModalName = payload.name;
          state.focusInModal = payload.focus === undefined ? true : payload.focus;
          state.modalContents = payload.contents;
          state.modalIndex = payload.index;
          state.modalType = payload.type;
        },
        closeModal(state, payload) {
          state.closeModalName = (payload) ? payload.name : state.activeModalName;
          state.activeModalName = "";
          state.modalContents = "";
          state.modalIndex = "";
          state.modalType = "";
          state.modalCloseReason = (payload) ? payload.reason : "";
        }
      },
      // Actions ----------------------------------------
      actions: {
        openModal({ commit, state }, payload) {
          commit("openModal", payload);
        },

        closeModal({ commit, state }, payload) {
          commit("closeModal", payload);
        }
      }
    };
  }

  getModule() {
    return this.module;
  }
}
